import { useQuery } from "@tanstack/react-query";
import analyticsService from "../services/analyticsService";

// Dashboard analytics hook with auto-refresh
export const useDashboardAnalytics = () => {
  return useQuery({
    queryKey: ["dashboard-analytics"],
    queryFn: analyticsService.getDashboard,
    refetchInterval: 30000, // Auto-refresh every 30 seconds
    staleTime: 25000, // Consider data stale after 25 seconds
    cacheTime: 300000, // Keep in cache for 5 minutes
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
};

// Cost analytics hook
export const useCostAnalytics = () => {
  return useQuery({
    queryKey: ["cost-analytics"],
    queryFn: analyticsService.getCost,
    staleTime: 60000, // Consider data stale after 1 minute
    cacheTime: 300000, // Keep in cache for 5 minutes
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
};

// Conversation analytics hook
export const useConversationAnalytics = () => {
  return useQuery({
    queryKey: ["conversation-analytics"],
    queryFn: analyticsService.getConversations,
    staleTime: 60000, // Consider data stale after 1 minute
    cacheTime: 300000, // Keep in cache for 5 minutes
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
};

// Daily analytics hook
export const useDailyAnalytics = () => {
  return useQuery({
    queryKey: ["daily-analytics"],
    queryFn: analyticsService.getDaily,
    staleTime: 60000, // Consider data stale after 1 minute
    cacheTime: 300000, // Keep in cache for 5 minutes
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
};

// Combined hook for all analytics (optional)
export const useAllAnalytics = () => {
  const dashboard = useDashboardAnalytics();
  const cost = useCostAnalytics();
  const conversation = useConversationAnalytics();
  const daily = useDailyAnalytics();

  return {
    dashboard,
    cost,
    conversation,
    daily,
    isLoading:
      dashboard.isLoading ||
      cost.isLoading ||
      conversation.isLoading ||
      daily.isLoading,
    isError:
      dashboard.isError ||
      cost.isError ||
      conversation.isError ||
      daily.isError,
    error: dashboard.error || cost.error || conversation.error || daily.error,
  };
};
